import { DATA_ROOM_VISITOR_KEY_LENGTH } from 'shared';

/**
 * The key a visitor's profile is addressed by, from their address — the same digest the server's
 * `dataRoomVisitorKey` stores on every event: the trimmed, lower-cased address, SHA-256, its first
 * 32 hex digits. For a card that names a person by email and links to their profile.
 */
export const visitorKeyOf = async (email: string): Promise<string> => {
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(email.trim().toLowerCase()),
  );

  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, DATA_ROOM_VISITOR_KEY_LENGTH);
};
